import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Tooltip from "@mui/material/Tooltip";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useTranslationsContext } from "../../../contexts/TranslationsContext";

type NotificationBellProps = {
  unreadCount: number;
  onClick: () => void;
};

export default function NotificationBell({
  unreadCount,
  onClick,
}: NotificationBellProps) {
  const { translation } = useTranslationsContext();

  return (
    <Tooltip title={translation.NOTIFY_TITLE?.defaultMessage || "Notifications"}>
      <IconButton
        size="small"
        onClick={onClick}
        aria-label={`${unreadCount} ${translation.NOTIFY_UNREAD_BADGE?.defaultMessage || "unread notifications"}`}
        sx={{ color: "rgba(255,255,255,0.8)" }}
      >
        <Badge
          badgeContent={unreadCount}
          max={99}
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: unreadCount > 0 ? "#cf8da8" : "transparent",
              color: unreadCount > 0 ? "#fff" : "transparent",
              fontSize: "0.65rem",
              minWidth: 16,
              height: 16,
            },
          }}
        >
          <NotificationsIcon sx={{ fontSize: 20 }} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
